import CryptoJS from 'crypto-js'

// download JSON data
export function downloadJSON (JSONData, fileTitle) {
  let strData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData
  let filename = fileTitle + (new Date().getTime())
  let blob = new Blob([JSON.stringify(strData)], {
    type: 'text/json;charset=utf-8;'
  })
  if (navigator.msSaveBlob) { //  IE 10+
    navigator.msSaveBlob(blob, filename)
  } else {
    let link = document.createElement('a')
    if (link.download !== undefined) {
      let url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.style = 'visibility:hidden'
      link.download = filename + '.json'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

// convert first data from JSON to CSV, then download CSV data
export function downloadCSVfromJSON (JSONData, fileTitle, shownLabel) {
  let arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData
  arrData.forEach(item => {
    if (item.kode_voucher) {
      let words = CryptoJS.enc.Base64.parse(item.kode_voucher)
      let decode = CryptoJS.enc.Utf8.stringify(words)
      item.kode_voucher = decode
    }
  })
  let CSV = ''
  if (shownLabel) {
    let row = ''
    for (let index in arrData[0]) {
      row += index + ';'
    }
    row = row.slice(0, -1)
    CSV += row + '\r\n'
  }
  for (let i = 0; i < arrData.length; i++) {
    let row = ''
    for (let index in arrData[i]) {
      row += `${arrData[i][index]};`
    }
    row.slice(0, row.length - 1)
    CSV += row + '\r\n'
  }
  if (CSV === '') {
    alert('Invalid data')
    return
  }
  let filename = fileTitle + ' - ' + (new Date().toISOString().substring(0, 10))
  let blob = new Blob([CSV], {
    type: 'text/csv;charset=utf-8;'
  })
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, filename)
  } else {
    let link = document.createElement('a')
    if (link.download !== undefined) {
      let url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.style = 'visibility:hidden'
      link.download = filename + '.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
